import React from 'react'
import Link from 'next/link'

import ParseHtml from '@/lib/utils/parse-html'

import { ListGridItem } from '@/components/list-grid/ListGrid'
import { HeadingFieldProps } from '@/types/types'

export default function Columns({ columns }) {
  return (
    <div className="component component--columns">
      <div className="container">
        <div className="flex w-full flex-wrap gap-l gap-y-l">
          {columns.map((column, index) => {
            const { acfe_layout_col: columnWidth, acf_fc_layout: columnType } = column

            let columnClass = ''

            switch (columnWidth) {
              case '3':
                columnClass = 'grow-[3] min-w-[min(100%,280px)]'
                break
              case '4':
                columnClass = 'grow-[4] min-w-[min(100%,360px)]'
                break
              case '6':
                columnClass = 'grow-[6] min-w-[min(100%,400px)]'
                break
              case '8':
                columnClass = 'grow-[8] min-w-[min(100%,400px)]'
                break
              case '9':
                columnClass = 'grow-[9] min-w-[min(100%,400px)]'
                break
              default:
                columnClass = 'grow-[6] min-w-[min(100%,400px)]'
                break
            }

            let columnContent = null

            switch (columnType) {
              case 'text':
                columnContent = (
                  <div className="style-lists">
                    <ParseHtml html={column.text} />
                  </div>
                )
                break
              case 'box':
                const {
                  text: boxTitle,
                  tag: boxTitleTag = 'h4',
                  class: boxTitleClass = 'h4',
                } = column.title as HeadingFieldProps

                const {
                  url: boxLinkUrl,
                  title: boxLinkTitle,
                  text: boxLinkText,
                  target: boxLinkTarget = '',
                } = column.button || {}

                columnContent = (
                  <div className="flex flex-col items-start gap-s bg-theme-alt p-l @container">
                    {boxTitle
                      ? React.createElement(
                          boxTitleTag,
                          { className: `${boxTitleClass} mb-0` },
                          boxTitle,
                        )
                      : null}

                    <div className="style-lists mb-0">
                      <ParseHtml html={column.text} />
                    </div>

                    {boxLinkUrl && boxLinkTitle ? (
                      <Link
                        className="btn btn--solid mt-s"
                        href={boxLinkUrl}
                        target={boxLinkTarget ?? '_self'}>
                        {boxLinkTitle}
                      </Link>
                    ) : null}
                  </div>
                )
                break
              case 'links':
                const { links } = column

                if (!links || !links.length) {
                  return null
                }

                columnContent = (
                  <ul>
                    {links.map((link, index) => {
                      return <ListGridItem link={link.link} key={index} />
                    })}
                  </ul>
                )

                break
            }

            return (
              <div key={index} className={`${columnClass} flex w-px flex-col gap-m ms:w-1/2`}>
                {columnContent}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
